import {
  ccTotalsShiftTypeNames,
  ccTotalsShiftTypes,
} from '@lp/features/Scheduler/SchedulerClinicalCoordinators/constants';
import { ResourceShiftTotalsMap } from '@lp/features/Scheduler/types';
import { ResourceShiftTotalsTable } from '@lp/features/Scheduler/components';
import { CCResource, CCShiftType } from '@/api/apis/resources/schedule';

type CCResourceShiftTotalsTableProps = {
  userRows: CCResource[];
  shiftTotalsMap?: ResourceShiftTotalsMap<CCShiftType>;
};

export const CCResourceShiftTotalsTable = ({ userRows, shiftTotalsMap }: CCResourceShiftTotalsTableProps) => {
  return (
    <ResourceShiftTotalsTable
      userRows={userRows}
      shiftTotalsMap={shiftTotalsMap}
      shiftTotalsTypeList={ccTotalsShiftTypes}
      shiftTotalsTypeNames={ccTotalsShiftTypeNames}
    />
  );
};
